import { GetActivePage } from './index';

export default 'bar';

export function getLayoutsByType(layouts, type) {
  return Object.values(layouts).filter(layout => layout[type]);
}

export function getCurrentPageLayout(pagesById, layouts) {
  const { layout } = GetActivePage(pagesById);
  return Object.values(layouts).find(element => element.id === layout);
}

export function getInnerPagesLayouts(pages) {
  return Object.values(pages).filter(page => !page.isCover && !page.isBackFlyLeaf && !page.isFrontFlyLeaf && !page.isBabyPage);
}

export function getPageLayoutByType(pages, type) {
  return Object.values(pages).find(page => page[type]);
}

export function getLayoutObjectByLayoutId(layoutId, layouts) {
  return Object.values(layouts).find(layout => layout.id === layoutId);
}

export function getInnerLayouts(layouts) {
  return Object.values(layouts).filter(layout => layout.isBabyPlaceholder !== true && layout.isBackFlyleaf !== true && layout.isFrontFlyleaf !== true && layout.isCover !== true);
}



// WEBPACK FOOTER //
// ./src/redux/helpers/layouts.js